export default "/images/vendor/flag-icons/flags/1x1/ug.svg?8da3e24988b4e67aa2b2d0763fa84aeb";